import { creatorLightTheme, createBasicColorSet, cssColorSet } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { hexToRgba } from '../colorConversion';
const { invertedDark, base } = creatorLightTheme;
export const getColorSet = (colors) => {
    if (colors.backgroundColor.toLowerCase() === invertedDark.background.base &&
        colors.textColor.toLowerCase() === invertedDark.text.base) {
        return {
            ...invertedDark,
            background: {
                ...invertedDark.background,
                tinted: {
                    ...invertedDark.background.tinted,
                    base: hexToRgba(colors.textColor, 0.08),
                    highlight: hexToRgba(colors.textColor, 0.1),
                },
            },
        };
    }
    if (colors.backgroundColor.toLowerCase() === base.background.base &&
        colors.textColor.toLowerCase() === base.text.base) {
        return base;
    }
    return {
        ...createBasicColorSet(colors.backgroundColor.toLowerCase(), colors.textColor.toLowerCase()),
        ...{
            text: {
                ...base.text,
                base: colors.textColor.toLowerCase(),
                subdued: colors.textColor.toLowerCase(),
            },
            decorative: {
                ...base.decorative,
                subdued: colors.textColor.toLowerCase().concat('1A'),
            },
            background: {
                ...base.background,
                base: colors.backgroundColor.toLowerCase(),
                tinted: {
                    ...base.background.tinted,
                    base: hexToRgba(colors.textColor, 0.08),
                },
            },
        },
    };
};
export const ColorSetWrapper = styled.div `
  ${({ colors }) => (colors === null || colors === void 0 ? void 0 : colors.backgroundColor) &&
    colors.textColor &&
    cssColorSet(getColorSet(colors))}
`;
